import { isModuleMissed } from './app';

appRunSettings.$inject = [
	'$rootScope',
	'$location',
	'$http',
	'$route',
	'$cookies',
	'accountService',
	'$timeout',
	'randomStringGenerator',
	'$analytics',
	'settingsService',
	'workflowService'
];

export function appRunSettings(
	$rootScope,
	$location,
	$http,
	$route,
	$cookies,
	accountService,
	$timeout,
	randomStringGenerator,
	$analytics,
	settingsService,
	workflowService
) {
	/* supports only latest version of Chrome, FF, Edge and Safari on Mac */
	const isNotSupportedBrowser =
		!Modernizr.flexbox || !Modernizr.sizes; /* to filter latest browsers */
	const isIE = !!document.documentMode; /* to filter IE 10++ */

	if (isNotSupportedBrowser && isIE) {
		return $location.path('/unsupported_browser');
	} else if (isAdBlockEnabled() && isModuleMissed) {
		$rootScope.adBlockEnabled = true;
	}

	let dateformat;
	let datetimepickerFormat;
	let weekStartsOn;

	Dropzone.autoDiscover = false;
	// enable loading indicator
	pace.start();

	$http.defaults.headers.common.UserTimezone = moment.tz.guess();

	$rootScope.baseApiUrl = window.baseApiHost;

	setupCommunicationAdapter();

	webshims.setOptions('forms-ext', {
		waitReady: false,
		loadStyles: false,
		extendNative: true,
		replaceUI: true,
		number: {
			calculateWidth: false
		},
		widgets: {
			startView: 0,
			minView: 0,
			inlinePicker: false,
			size: 1,
			noChangeDismiss: false,
			openOnFocus: true,
			buttonOnly: false,
			classes: '',
			popover: {
				appendTo: 'element'
			},
			calculateWidth: true,
			animate: true,
			toFixed: 0,
			onlyFixFloat: false
		}
	});

	webshims.formcfg.en.dFormat = '/';
	webshims.formcfg.en.dateSigns = '/';
	webshims.formcfg.en.patterns.t = 'HH:mm a';
	webshims.formcfg.de = angular.copy(webshims.formcfg.en);
	webshims.formcfg.fr = angular.copy(webshims.formcfg.en);

	webshims.formcfg.de.date.dayNamesMin = [
		'Fr',
		'Th',
		'We',
		'Tu',
		'Mo',
		'Su',
		'Sa'
	];
	webshims.formcfg.de.date.dayNames = [
		'Friday',
		'Thursday',
		'Wednesday',
		'Tuesday',
		'Monday',
		'Sunday',
		'Saturday'
	];

	webshims.formcfg.en.patterns.d = 'dd/mm/yy';
	webshims.formcfg.fr.patterns.d = 'mm/dd/yy';

	settingsService.timeFormatSettings.subscribe(data => {
		dateformat = data.dateFormat;
		datetimepickerFormat = dateformat === 'DD_MM_YYYY' ? 'en' : 'fr';

		switch (data.weekStartsOn) {
			case 'SATURDAY':
				weekStartsOn = 6;
				datetimepickerFormat = 'de';
				break;
			case 'SUNDAY':
				weekStartsOn = 0;
				break;
			case 'MONDAY':
				weekStartsOn = 1;
				break;
			default:
				break;
		}

		webshims.formcfg.en.date.firstDay = weekStartsOn;
		webshims.formcfg.fr.date.firstDay = weekStartsOn;
		webshims.formcfg.de.date.firstDay = weekStartsOn;
		webshims.formcfg.de.patterns.d =
			dateformat === 'DD_MM_YYYY' ? 'dd/mm/yy' : 'mm/dd/yy';

		webshims.activeLang(datetimepickerFormat);
		webshims.polyfill('forms-ext');
	});

	toastr.options = {
		iconClasses: {
			error: 'toast-warning toast-error',
			warning: 'toast-warning toast-warning-custom',
			success: 'toast-success',
			info: 'toast-info'
		},
		closeButton: true,
		debug: false,
		newestOnTop: false,
		progressBar: true,
		positionClass: 'toast-top-right',
		preventDuplicates: true,
		onclick: null,
		showDuration: '3000',
		hideDuration: '1000',
		timeOut: '5000',
		extendedTimeOut: '1000',
		showEasing: 'swing',
		hideEasing: 'linear',
		showMethod: 'fadeIn',
		hideMethod: 'fadeOut'
	};

	accountService.emitShowHeader(true);
	$rootScope.showLogo = true;
	$rootScope.$back = function() {
		window.history.back();
	};

	accountService.userLoginActionObservable
		.filter(data => !!data)
		.subscribe(() => {
			$rootScope.removeBg = 'blah';
			$location.path('/');
		});

	//  Changing angular-text default styling

	const mailStyling = id => {
		const styleObj = {
			P: 'margin:0 0 2px;',
			LI: 'margin-bottom:1px;',
			SPAN: 'padding:0;',
			DIV: 'margin:0;',
			BLOCKQUOTE:
				'margin: 0 0 0 0.8ex; border-left: 1px #ccc solid; padding-left: 1ex;'
		};

		const defaultStyle = 'font-size:14px;color:#000000;line-height:22px;';
		const allTags = $(id).find('*');

		$('.edit-link__tips').remove();
		$('.edit-link__elem').removeClass('edit-link__elem');

		let i = 0,
			max = allTags.length;

		for (; i < max; i += 1) {
			const thisTag = allTags.eq(i);

			let tagStyle = '';
			const textAlign = thisTag.css('text-align');

			if (textAlign) {
				tagStyle += `text-align:${textAlign};`;
			}
			const thatTag = thisTag.prop('tagName');

			tagStyle += styleObj[thatTag] || '';
			tagStyle += defaultStyle;

			if (thatTag == 'A') {
				tagStyle += 'color:#337ab7;';
			}

			thisTag.attr('style', tagStyle);
		}
	};

	$rootScope.addMaiStyling = function(emailText) {
		const emptyParagraph = '<p></p>';

		if (!emailText) {
			return '';
		}

		if (emailText === emptyParagraph) {
			return '';
		}

		const tmpId = `textAngular_styling_${randomStringGenerator.getMixedString(
			9
		)}`;
		const $tmpId = `#${tmpId}`;

		$(document.body).append(`<div id="${tmpId}" class="hide"></div>`);
		$($tmpId).append(emailText);

		mailStyling($tmpId);

		const message = $($tmpId).html();
		$($tmpId).remove();

		return message;
	};

	$rootScope.setTimeZoneInCookie = function() {
		const _myDate = new Date();
		const _offset = _myDate.getTimezoneOffset();

		$cookies.put('TIMEZONE_COOKIE', _offset);
	};

	$rootScope.setTimeZoneInCookie();

	$rootScope.dateLongPattern = 'dd MMMM yyyy';

	const removeViewContentLoadedListener = $rootScope.$on(
		'$viewContentLoaded',
		() => {
			workflowService.setLabelsToTaskDateSequence();

			const $modals = $('.modal-backdrop.fade.in');

			document.body.classList.remove('modal-open');
			document.body.style.paddingRight = '';

			$modals.hide();
			$modals.removeClass('in');
			delete $rootScope.error;
		}
	);

	const removeRouteChangeSuccessListener = $rootScope.$on(
		'$routeChangeSuccess',
		(event, currentRoute) => {
			if (currentRoute.title && $rootScope.gotoPage) {
				if (currentRoute.title.includes('Dashboard')) {
					$location.path($rootScope.gotoPage);
				}

				delete $rootScope.gotoPage;
			}

			document.title = currentRoute.title
				? `Studio Ninja ${currentRoute.title}`
				: 'Studio Ninja ';

			// to prevent showing title of previous page
			setTimeout(() => {
				window.scrollTo(0, 0);
				$analytics.pageTrack($location.path());
			}, 0);
			Intercom('update');
		}
	);

	const removeRouteChangeStartListener = $rootScope.$on(
		'$routeChangeStart',
		() => {
			window.scrollTo(0, 0);
			if (isAdBlockEnabled() && isModuleMissed) {
				$rootScope.adBlockEnabled = true;
			}
		}
	);

	$rootScope.$on('$destroy', () => {
		removeRouteChangeStartListener();
		removeRouteChangeSuccessListener();
		removeViewContentLoadedListener();
	});

	$rootScope.getClass = function(path) {
		let locationPath = $location.path();

		if (locationPath.includes('/invoices')) {
			locationPath = '/payments';
		}

		if (path === '/') {
			if (
				locationPath.substring(
					0,
					location.protocol.length + location.host.length
				) === path
			) {
				return 'selected-menu';
			}
			return 'not-selected-menu';
		}
		if (locationPath.includes(path)) {
			return 'selected-menu';
		}
		return 'not-selected-menu';
	};

	$rootScope.sidebarClick = function() {
		$rootScope.showmen = !$rootScope.showmen;
	};

	$rootScope.closeSandwich = function() {
		$rootScope.showmen = !$rootScope.showmen;
	};

	$rootScope.getSettingsClass = function(path) {
		if ($location.path().indexOf(path) > -1) {
			return 'nav-item-active';
		}
		return 'nav-item-nonactive';
	};

	function isAdBlockEnabled() {
		let isAdBlockEnabled = false;

		const test = document.createElement('div');
		test.innerHTML = '&nbsp;';
		test.className = 'adsbox';
		document.body.appendChild(test);

		if (test.offsetHeight === 0) {
			isAdBlockEnabled = true;
		}

		test.remove();

		return isAdBlockEnabled;
	}

	// change path without reloading
	const original = $location.path;
	$location.path = (path, reload) => {
		if (reload === false) {
			const lastRoute = $route.current;
			const un = $rootScope.$on('$locationChangeSuccess', () => {
				$route.current = lastRoute;
				un();
			});
		}
		return original.apply($location, [path]);
	};

	function setupCommunicationAdapter() {
		function CommunicationAdapterBlueprint() {
			this._registry = [];

			this.registerMethod = function(name, method) {
				const index = this._registry.findIndex(
					element => element.name === name
				);

				if (index > -1) {
					this._registry[index].method = method;
				} else {
					this._registry.push({ name, method });
				}
			};

			this.callMethod = function(name, ...args) {
				const found = this._registry.find(element => name === element.name);

				if (found) {
					if (args.length === 0) {
						found.method();
					} else {
						found.method(...args);
					}
				}
			};
		}

		window.snCommunicationAdapter = new CommunicationAdapterBlueprint();
	}

	$rootScope.drawBuildVersionLabel = function(buildVersionElement) {
		const buildVersionLabel = window.buildVersionLabel;

		if (buildVersionLabel && buildVersionLabel !== '') {
			document.getElementById(
				buildVersionElement
			).innerHTML = buildVersionLabel;
		}
	};
}



// WEBPACK FOOTER //
// ./web/js/app.run.js